module.exports = __webpack_public_path__ + "static/media/chicken.b89543da.png";